/* eslint-disable linebreak-style */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
/* eslint-disable import/extensions */

import React from 'react';

import { Fade } from 'react-awesome-reveal';

import Button from '../elements/Button';

export default function Portfolio({ data }) {
  // Show only first 6 items on landing page
  const displayData = data.slice(0, 6);

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <Fade direction="up" triggerOnce>
          <div className="text-center mb-16">
            <p className="text-sm font-medium text-theme-purple uppercase tracking-wider mb-3">
              Our Portfolio
            </p>
            <h2 className="text-4xl md:text-5xl text-theme-blue font-bold mb-4">
              Featured Projects
            </h2>
            <p className="text-lg text-gray-500 max-w-2xl mx-auto">
              A showcase of our successful mobile applications across different industries
            </p>
          </div>
        </Fade>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {displayData.map((item, index) => (
            <Fade direction="up" triggerOnce delay={index * 100} key={item.id}>
              <Button type="link" href={`/project/${item.id}`} className="block">
                <div className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer">
                  {/* Image container */}
                  <div className="relative aspect-[4/3] overflow-hidden">
                    <img
                      src={item.imageUrl}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    {/* Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-theme-blue/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="absolute bottom-4 left-4 right-4">
                        <span className="inline-flex items-center gap-2 text-white font-medium">
                          View Project
                          <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-theme-blue mb-2 group-hover:text-theme-purple transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-gray-500 text-sm mb-3">{item.type}</p>

                    {/* Tags */}
                    <div className="flex flex-wrap gap-2">
                      {item.responsibility.slice(0, 2).map((tag) => (
                        <span
                          key={tag}
                          className="px-3 py-1 bg-theme-purple/10 text-theme-purple text-xs font-medium rounded-full"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </Button>
            </Fade>
          ))}
        </div>

        <Fade direction="up" delay={600} triggerOnce>
          <div className="text-center mt-12">
            <Button
              href="/project"
              type="link"
              className="inline-flex items-center px-8 py-4 text-theme-purple font-medium border-2 border-theme-purple rounded-xl hover:bg-theme-purple hover:text-white transition-all duration-300 cursor-pointer"
            >
              View All Projects
              <svg className="w-5 h-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Button>
          </div>
        </Fade>
      </div>
    </section>
  );
}
